import React from "react";
import { Controller } from "react-hook-form";
import SelectInput from "./SelectInput";

export default function SearchableSelect(props) {

    return (
        (props.control && props.name) ?
            <Controller
                name={props.name}
                control={props.control}
                rules={props.rules}
                defaultValue={props.defaultValue}
                render={(field, formState) => (
                    <SelectInput
                        defaultLabel={props.defaultLabel}
                        value={props.value}
                        field={field}
                        error={formState?.errors?.[props.name]}
                        {...props}
                    />
                )}
            /> :
            <SelectInput
                defaultLabel={props.defaultLabel}
                value={props.value}
                {...props}
            />


    );
}